import { inject, injectable } from 'inversify';
import { isAxiosError } from 'axios';
import TwilioVerificationService from 'src/features/verification/data/service/TwilioVerificationService';
import {
  TwilioSendVerificationCodeParams,
  TwilioVerifyCodeParams,
} from 'src/features/verification/data/service/TwilioVerificationService.types';
import {
  TwilioVerificationError,
  TwilioVerificationErrorCode,
  TwilioVerificationRepositoryInterface,
} from 'src/features/verification/domain/TwilioVerificationRepositoryInterface';

@injectable()
class TwilioVerificationRepository
  implements TwilioVerificationRepositoryInterface
{
  @inject(TwilioVerificationService)
  private readonly verificationService!: TwilioVerificationService;

  public async sendVerificationCode(params: TwilioSendVerificationCodeParams) {
    try {
      const response =
        await this.verificationService.sendVerificationCode(params);

      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  public async verifyCode(params: TwilioVerifyCodeParams) {
    try {
      const response = await this.verificationService.verifyCode(params);

      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  private handleError<E extends TwilioVerificationErrorCode>(error: unknown) {
    if (isAxiosError(error) && error?.response?.data.code) {
      const code = error.response?.data?.code as E | E[];

      throw new TwilioVerificationError(code);
    }

    throw new TwilioVerificationError(TwilioVerificationErrorCode.UnknownError);
  }
}

export default TwilioVerificationRepository;
